import { z } from 'zod';

import { uuidValidator } from '../../validators';

export const DeleteBooksSchema = z.object({
  ids: z.array(uuidValidator).min(1, 'At least one book ID must be provided'),
});

export type IDeleteBooksDto = z.infer<typeof DeleteBooksSchema>;
